((document, Drupal) => {
  "use strict";

  Drupal.behaviors.tabs = {
    attach: function (context) {

      /**
       * Activates a tab and its corresponding panel.
       * Updates aria-selected, tabindex, hidden, and is-active on all siblings.
       */
      function activateTab(tab, tabList) {
        const allTabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const tabsWrapper = tabList.closest('.tabs__wrapper');
        const allPanels = tabsWrapper
          ? Array.from(tabsWrapper.querySelectorAll('[role="tabpanel"]'))
          : [];

        // Deactivate all tabs and hide all panels.
        allTabs.forEach(function (t, i) {
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
          const listItem = t.closest('.tabs__item');
          if (listItem) listItem.classList.remove('is-active');
          if (allPanels[i]) {
            allPanels[i].setAttribute('hidden', '');
            allPanels[i].classList.remove('is-active');
          }
        });

        // Activate the target tab and reveal its panel.
        const tabIndex = allTabs.indexOf(tab);
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
        const activeItem = tab.closest('.tabs__item');
        if (activeItem) activeItem.classList.add('is-active');
        if (allPanels[tabIndex]) {
          allPanels[tabIndex].removeAttribute('hidden');
          allPanels[tabIndex].classList.add('is-active');
        }

        if (Drupal.behaviors.resourceTeaser) {
          Drupal.behaviors.resourceTeaser.attach();
        }
      }

      // Target only interactive tab widgets; exclude Drupal nav tabs.
      const tabLists = context.querySelectorAll(
        '.tabs__wrapper:not(.tabs--primary):not(.tabs--secondary) [role="tablist"]'
      );

      tabLists.forEach(function (tabList) {
        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const isVertical = tabList.getAttribute('aria-orientation') === 'vertical';

        // Initialize on page load: activate the tab marked active in HTML,
        // falling back to the first tab. This makes the correct panel visible.
        const initialTab = tabs.find(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        }) || tabs[0];
        if (initialTab) {
          activateTab(initialTab, tabList);
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            activateTab(tab, tabList);
          });

          // Keyboard navigation per W3C ARIA APG Tabs pattern.
          tab.addEventListener('keydown', function (event) {
            const prevKey = isVertical ? 'ArrowUp' : 'ArrowLeft';
            const nextKey = isVertical ? 'ArrowDown' : 'ArrowRight';
            const currentIndex = tabs.indexOf(tab);
            let targetTab = null;

            switch (event.key) {
              case ' ':
                // Explicitly handle Space so it activates the tab and does
                // not scroll the page (buttons fire click on Space natively,
                // but we control it here for clarity and to call preventDefault).
                event.preventDefault();
                activateTab(tab, tabList);
                break;
              case nextKey:
                event.preventDefault();
                targetTab = tabs[(currentIndex + 1) % tabs.length];
                break;
              case prevKey:
                event.preventDefault();
                targetTab = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
                break;
              case 'Home':
                event.preventDefault();
                targetTab = tabs[0];
                break;
              case 'End':
                event.preventDefault();
                targetTab = tabs[tabs.length - 1];
                break;
            }

            if (targetTab) {
              targetTab.focus();
              activateTab(targetTab, tabList);
            }
          });
        });
      });

    },
  };
})(document, Drupal);
